import { render, staticRenderFns } from "./SofiaFilterModals.vue?vue&type=template&id=1f93da03&lang=pug&"
import script from "./SofiaFilterModals.vue?vue&type=script&lang=js&"
export * from "./SofiaFilterModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports